import * as modules from "./modules/";
import config from "../../../../config";
const { vendor } = config;

const MobileNavigationIcon = modules[vendor]
  ? modules[vendor]
  : modules["default"];

export default MobileNavigationIcon;
